import { render, staticRenderFns } from "./AccountConnector.vue?vue&type=template&id=047778bb&scoped=true"
import script from "./AccountConnector.vue?vue&type=script&lang=js"
export * from "./AccountConnector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047778bb",
  null
  
)

export default component.exports